const STATUS_COM_VALIDACAO = [0, 2, 3, 10];
const STATUS_DINHEIRO_SEM_DOCUMENTO = [0, 3, 10];

export const ePagamentoExclusivamenteDinheiro = (titulos, tipoDinheiro) =>
  Array.isArray(titulos) &&
  titulos.length > 0 &&
  titulos.every(titulo => titulo.tipo === tipoDinheiro);

export const permiteValidacaoComprovante = ({
  statusDocumentacao,
  titulos,
  quantidadeDocumentos,
  tipoDinheiro,
}) => {
  const status = parseInt(statusDocumentacao, 10);

  if (STATUS_COM_VALIDACAO.indexOf(status) === -1) return false;

  return (
    quantidadeDocumentos > 0 ||
    (STATUS_DINHEIRO_SEM_DOCUMENTO.indexOf(status) > -1 &&
      ePagamentoExclusivamenteDinheiro(titulos, tipoDinheiro)) ||
    status === 0
  );
};
